import React from "react";
import PropTypes from "prop-types";
import tw from "tailwind-styled-components";

const ButtonSC = tw.button`
inline-flex 
items-center 
px-3 
py-2 
border
border-transparent
text-sm 
shadow
leading-4 
font-medium 
rounded-md  
focus:outline-none 
${(p) => {
  if (p.disabled) {
    return "bg-gray-300 cursor-not-allowed text-gray-400";
  }
  switch (p.intent) {
    case "link":
      return "bg-white hover:bg-gray-200 text-gray-700 rounded-md border shadow";
    case "danger":
      return "text-red-700 bg-red-100 hover:bg-red-200";
    case "success":
      return "text-green-700 bg-green-100 hover:bg-green-200";
    case "nooutline":
      return "bg-white hover:bg-gray-200 text-gray-700";
    default:
      return "text-sky-700 bg-sky-100 hover:bg-sky-200";
  }
}}`;

export default function Button(props) {
  return <ButtonSC {...props}>{props.children}</ButtonSC>;
}

Button.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  intent: PropTypes.string,
};
